import { show_multiple_choice_modal } from './global';

$(document).on('turbo:load', function() {
  const form = $('form.promotion-form');
  if (!form.length) return;

  const planNameInput = form.find('#promotion_plan_name');
  const hosterInput = form.find('#promotion_hoster_id');
  let pendingRequest;
  let lookupVersion = 0;

  function fillPlanDetails() {
    const version = ++lookupVersion;
    if (pendingRequest) pendingRequest.abort();

    const planName = planNameInput.val().trim();
    const hosterId = hosterInput.val();
    if (!planName) return;

    pendingRequest = $.getJSON(form.data('plan-details-url'), {
      plan_name: planName,
      hoster_id: hosterId
    }).done(function(details) {
      if (version !== lookupVersion || planNameInput.val().trim() !== planName || hosterInput.val() !== hosterId) return;

      const message = $('<div>').text(`Do you want to auto-fill specs and regular prices for plan "${planName}"?`).html();
      show_multiple_choice_modal(message, 'Yes', 'No', function() {
        if (version !== lookupVersion || planNameInput.val().trim() !== planName || hosterInput.val() !== hosterId) return;

        $.each(details, function(field, value) {
          const input = form.find('#promotion_' + field);
          if (input.is(':checkbox')) {
            input.prop('checked', Boolean(value));
          } else {
            input.val(value == null ? '' : value);
          }
          input.trigger('change');
        });
      }, null);
    });
  }

  planNameInput.off('blur.promotionPlan').on('blur.promotionPlan', fillPlanDetails);
  hosterInput.off('change.promotionPlan').on('change.promotionPlan', fillPlanDetails);
});